// @flow

/**
 * Base class for all Large containers which we can show.
 */
export default class LargeContainer {
    /**
     * Show this container.
     *
     * @returns {Promise}
     */
    show() {
        return Promise.resolve();
    }

    /**
     * Hide this container.
     *
     * @returns {Promise}
     */
    hide() {
        return Promise.resolve();
    }

    /**
     * Resize this container.
     *
     * @param {number} _containerWidth - Available width.
     * @param {number} _containerHeight - Available height.
     * @param {boolean} _animate - If container should animate its resize process.
     * @returns {void}
     */
    resize(_containerWidth: number, _containerHeight: number, _animate?: boolean) {
        return undefined;
    }

    /**
     * Handler for "hover in" events.
     *
     * @param {Object} _e - Hover event.
     * @returns {void}
     */
    onHoverIn(_e?: Object) {
        return undefined;
    }

    /**
     * Handler for "hover out" events.
     *
     * @param {Object} _e - Hover event.
     * @returns {void}
     */
    onHoverOut(_e?: Object) {
        return undefined;
    }

    /**
     * Update video stream.
     *
     * @param {string} _userID
     * @param {Object?} _stream - New stream.
     * @param {string} _videoType - Video type.
     * @returns {void}
     */
    setStream(_userID: string, _stream: ?Object, _videoType: string) {
        return undefined;
    }

    /**
     * Show or hide user avatar.
     *
     * @param {boolean} _show
     * @returns {void}
     */
    showAvatar(_show: boolean) {
        return undefined;
    }

    /**
     * Whether current container needs to be switched on dominant speaker event
     * when the container is on stage.
     *
     * @returns {boolean}
     */
    stayOnStage() {
        return false;
    }
}
